<template>
	<div class="row">
		<div class="col-12">
			<div class="row">
				<div class="col-12 titulo-paso">CSV Details (Obligatorio)</div>
			</div>
			<div class="row">
				<div class="col-12 text-right">
					<b-button id="seguir" variant="success" v-on:click="seguir" :disabled="!disabled">SEGUIR</b-button>
					<hr />
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<label class="control-label">Seleccione año y mes</label>
				</div>
			</div>
			<div class="row">
				<div class="col-md-3">
					<b-select id="anio" size="sm" :options="anios" v-model="anio" @change="seleccionaPeriodo">
						<template #first>
							<b-form-select-option :value="null">Año</b-form-select-option>
						</template>
					</b-select>
				</div>
				<div class="col-3">
					<b-select id="mes" size="sm" :options="meses" v-model="mes" @change="seleccionaPeriodo">
						<template #first>
							<b-form-select-option :value="null">Mes</b-form-select-option>
						</template>
					</b-select>
				</div>
			</div>
			<p></p>
			<div v-if="anio != null && mes != null" class="row">
				<div class="col-10">
					<label class="control-label">A continuación: sube el archivo con la planilla completa</label>
					<upload-excel type="csv" :on-success="onSuccess" :before-upload="beforeUpload" />
				</div>
			</div>
			<p></p>
			<div v-if="noformato" class="row">
				<div class="col-12 text-center">
					<div class="row">&nbsp;</div>
					<div class="row">
						<div class="col-12">
							<h5><i class="fas fa-exclamation fa-fw" /> El formato del archivo no corresponde</h5>
						</div>
					</div>
				</div>
			</div>
			<div v-if="validacion" class="row">
				<div class="col-8 offset-2">
					<b-progress max=100 variant="success">
						<b-progress-bar :value="avance">{{ avance }}%</b-progress-bar>
					</b-progress>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import $ from "jquery"
	import UploadExcel from "./upload_excel.vue"


	export default 
	{
		name: "Paso1",
		components: { UploadExcel },
		props: {
			onPeriodo: Function, // Funcion callback para informar el periodo seleccionado
			onAvanzar: Function, // Funcion callback para la accion de avanzar en el wizard
			onArchivo: Function, // Funcion callback para informar sobre el archivo cargado
		},
		data() {
			return {
				nombre: "fn_detail_15", // Tipo de archivo a cargar
				periodo: "",
				anio: null,
				mes: null,
				anios: [],
				meses: [ 
					{ value: "01", text: "Enero" }, 
					{ value: "02", text: "Febrero" },
					{ value: "03", text: "Marzo" },
					{ value: "04", text: "Abril" },
					{ value: "05", text: "Mayo" },
					{ value: "06", text: "Junio" },
					{ value: "07", text: "Julio" },
					{ value: "08", text: "Agosto" },
					{ value: "09", text: "Septiembre" },
					{ value: "10", text: "Octubre" },
					{ value: "11", text: "Noviembre" },
					{ value: "12", text: "Diciembre" } 
				],
				disabled: false, // Flag que controla cuando activar el boton SEGUIR
				formatos: [
					[ "invoice_id","invoice_code","invoice_date","sale_code","sale_date","invoice_issuer","district_","client_id","client_name","client_address","client_billing_period","client_city","client_country","client_post_code","client_tax_code","client_type","email_invoice_recipients","company_id","country","region","slug","client_payment_terms","invoive_tax_region_state","user_email_default_payment","sale_description","km","org_unit_name","charge_code","default_charge_code","employee_code","cost","invoice_price","invoice_discount","invoice_total" ],
					[ "invoice_id","invoice_code","invoice_date","sale_code","sale_date","invoice_issuer","district","client_id","client_name","client_address","client_billing_period","client_city","client_country","client_post_code","client_tax_code","client_type","email_invoice_recipients","company_id","country","region","slug","client_payment_terms","invoive_tax_region_state","user_email_default_payment","sale_description","km","org_unit_name","charge_code","default_charge_code","employee_code","cost","invoice_price","invoice_discount","invoice_total" ],
					[ "sale_code","sale_date","issuer_name","client_id","client_name","client_type","company_id","company_name","region","slug","client_tax_code","client_address","client_city","client_country","client_post_code","client_payment_term","client_payment_term_(sale)","billing_period","journey_id","invoice_code","invoice_date","skip_invoicin g","sale_description","n_km","sale_rectify_code","sale_rectify_date","sale_rectify_tax_region_state","payment_method_rider","district","cost","price","discount","neto","base_imponible","iva.","total" ],
				],
				noformato: false,
				validacion: false,
				avance: 0,
			}
		},
		created() {

			// Rutina que llena la lista de anios disponibles para seleccionar
			// Desde el año actual, avanza 5 años hacia el futuro
			const now = new Date()
			var anio = now.getFullYear() - 1
			for (var a = anio; a <= anio + 5; a++)
				this.anios.push({ value: a, text: a })
		},
		methods: {

			// Para seleccionar el año y el mes
			seleccionaPeriodo() {

				this.anio = $("#anio").val() != "" ? $("#anio").val() : null
				this.mes = $("#mes").val() != "" ? $("#mes").val() : null

				// Si se eligio mes y año, cambiamos validacion a TRUE para mostrar la opcion para subir el archivo
				if (this.anio != null && this.mes != null)
				{
					this.periodo = this.anio + "-" + this.mes

					if (this.onPeriodo)
						this.onPeriodo(this.periodo)
				}
			},

			// Se ejecuta antes de comenzar a leer el archivo
			// Sirve para activar el icono de espera
			beforeUpload() {

				this.noformato = false
				// Activamos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

				return true
			},

			// Se ejecuta una vez que se leyo todo el archivo
			// Desactiva el icono de espera y valida el formato del archivo cargado
			// Envia los datos al servidor
			onSuccess(header, data, file) {

				// Ocultamos la imagen cargando
				window.event.$emit("mostrar-cargando", false)

				var valido = false
				for (var formato of this.formatos)
				{
					if (header.join() == formato.join())
					{
						valido = true
						break
					}
				}

				if (valido) {

					// Llamamos a la funcion callback para enviar la info del archivo cargado
					if (this.onArchivo)
						this.onArchivo({ archivo: this.nombre, nombre: file.name, tipo: file.type, tamanio: file.size, registros: data.length, avance: 0 })

					this.procesar(file)

				} else
					this.noformato = true

				this.validacion = !this.noformato
			},

			procesar(file) {

				var request = new FormData()
				request.append("archivo", file)

				var header = {
					"Content-Type": file.type,
					"usuario": this.$usuario,
					"destino": this.$env,
					"proceso": "upDataFac",
					"archivo": this.nombre,
					"periodo": this.periodo,
				}

				// Variable para usar en la funcion del callback del evento UploadProgress, para poder actualizar el avance en la barra de progreso
				var that = this

				axios.post("/faceZip", request, {
					headers: header,
					onUploadProgress: function(event) { that.avance = Math.round((event.loaded / event.total) * 100) }
				}).then(response => {

					// Activamos el boton SEGUIR, cuando finaliza la subida del archivo
					this.disabled = true

				}).catch(ex => {

					console.log(ex.message)
				})
			},

			// Informa al padre (main.vue) que debe avanzar al siguiente paso, llamando a la funcion de callback
			seguir() {

				if (this.onAvanzar)
					this.onAvanzar()
			}

		}
	}

</script>
<style scoped>

	.total-filtro {
		padding-top: 3px;
		font-size: 14px;
	}

</style>
